"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const SegmentControl = ({ children, style }) => {
    const segmentStyle = Object.assign({ alignItems: 'center', border: `2px solid ${colors_1.turquoise}`, borderRadius: 4, display: 'flex', height: 24 }, style);
    return React.createElement("div", { style: segmentStyle }, children);
};
exports.default = SegmentControl;
